'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = function () {
  function Content() {
    (0, _classCallCheck3.default)(this, Content);
  }

  (0, _createClass3.default)(Content, null, [{
    key: 'renderDates',
    value: function renderDates(styles, dates) {
      var showId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var generatedDates = [];

      dates.forEach(function (item, key) {
        generatedDates.push(_react2.default.createElement(
          _reactRouter.Link,
          { to: item.url, title: item.title, className: (0, _classnames2.default)('date', styles.date), key: key },
          _react2.default.createElement(
            'strong',
            { className: 'nice' },
            item.date
          ),
          typeof item.subTitle !== 'undefined' && _react2.default.createElement(
            'div',
            { className: 'subTitle' },
            item.subTitle
          ),
          typeof item.place !== 'undefined' && _react2.default.createElement(
            'div',
            { className: 'place' },
            item.place
          ),
          typeof item.rest !== 'undefined' && _react2.default.createElement(
            'div',
            { className: 'capacity' },
            item.rest === 0 && 'PLNĚ OBSAZENO',
            item.rest === 2 && '2 volná místa',
            item.rest === 3 && '3 volná místa',
            item.rest === 5 && '5 a více volných míst',
            item.rest === 10 && '10 a méně volných míst',
            item.rest === 15 && '15 a méně volných míst',
            item.rest === 30 && '30 a více volných míst'
          ),
          _react2.default.createElement(
            'svg',
            { xmlns: 'http://www.w3.org/2000/svg', width: '200px', height: '160px' },
            _react2.default.createElement('path', { strokeWidth: '5px', d: 'M3,60 C5,10 20,3 100,10 170,10 195,3 197,60 196,115 190,115 100,110 12,117 10,112 3,60' })
          )
        ));
      });

      return _react2.default.createElement(
        'div',
        { id: showId ? 'terminy' : '', className: 'container dates' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          showId && _react2.default.createElement(
            'div',
            { className: 'col-xs-12' },
            _react2.default.createElement(
              'h2',
              null,
              'Nyn\xED si sta\u010D\xED u\u017E jen vybrat term\xEDn'
            )
          ),
          generatedDates
        )
      );
    }
  }, {
    key: 'renderIntro',
    value: function renderIntro(styles, intro) {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('container-fluid intro', styles.intro) },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-8' },
              _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: intro.text } })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-4 intro-image' },
              _react2.default.createElement('img', { src: intro.image.src, alt: intro.image.alt })
            )
          )
        )
      );
    }
  }, {
    key: 'renderPhotos',
    value: function renderPhotos(styles, photos) {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('row photos chapter', styles.photos) },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(
            'h2',
            null,
            photos.heading
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-4' },
          _react2.default.createElement('img', { src: photos.photo1.src, alt: photos.photo1.alt })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-4' },
          _react2.default.createElement('img', { src: photos.photo2.src, alt: photos.photo2.alt })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-4' },
          _react2.default.createElement('img', { src: photos.photo3.src, alt: photos.photo3.alt })
        )
      );
    }
  }]);
  return Content;
}();

exports.default = Content;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Content.js
// module id = 65
// module chunks = 0